/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Metrics_Total_Words_HeaderInputs */



/**
* | output |
* | --- |
* | "Total Words" |
*
* @param {Speakers_Metrics_Total_Words_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_total_words_header = /** @type {((inputs?: Speakers_Metrics_Total_Words_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Total_Words_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Total Words")
	if (locale === "de") return /** @type {LocalizedString} */ ("Total Words")
	if (locale === "it") return /** @type {LocalizedString} */ ("Total Words")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Total Words")
	if (locale === "es") return /** @type {LocalizedString} */ ("Total Words")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Total Words")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Total Words")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Total Words")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Total Words")
	return /** @type {LocalizedString} */ ("Total Words")
});